export const styles = {
    autoCompleteStyles: {
        width: '100%',
        '& .MuiFormControl-root': {
            width: '100%',
        },
    },
    smartContractAutocompleteFieldHeight: {
        maxHeight: '132px',
    },
};
